import { render, staticRenderFns } from "./pages-desc.vue?vue&type=template&id=029f76dc"
import script from "./pages-desc.vue?vue&type=script&lang=js"
export * from "./pages-desc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports